// Industry API
import ajax from './_ajax';

const api = {};
api.industryGetAll = function () {
  return ajax.post('/api/Industry/GetAll');
};
api.industryGetInfoById = function (id) {
  return ajax.get('/api/Industry/GetInfoById?id=' + id);
};
api.applicationEquipmentGetInfoById = function (id) {
  return ajax.get('/api/Industry/GetApplicationEquipmentById?id=' + id);
};
api.articleGetInfoById = function (id) {
  return ajax.get('/api/Article/GetInfoById?id=' + id);
};
api.articleGetAll = function (params) {
  return ajax.post('/api/Article/GetAll', params);
};
api.getAllProductsByEquipment = function (params) {
  return ajax.post('/api/Product/GetAllProductsByEquipment', params);
};
api.getAllProductsByArticles = function (params) {
  return ajax.post('/api/Product/GetAllProductsByArticles', params);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/industryApi.js